<template>
  <v-autocomplete
    :items="items"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="pl-14px py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todas</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="updateModel(Helpers.arrayColumn(items, 'id'))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todas</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}">
      <template v-if="modelValue.indexOf(item.id) < qtde_visivel_selecionados">
        <span>{{item.descricao}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.id) === qtde_visivel_selecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtde_visivel_selecionados}})</span>
      </template>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import {arrayColumn, logout} from "@/helpers";
import api from "@/api/api";

export default {
  name: "SysSecaoAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    qtde_visivel_selecionados: {
      type: Number,
      default: 1
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    idsGrupo: {
      type: Array,
      default: () => ([])
    },
    idsFilial: {
      type: Array,
      default: () => ([])
    },
    idsSegmento: {
      type: Array,
      default: () => ([])
    },
    idsSecao: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    items: [],
    loading: false,
    timer_buscar_items: null
  }),
  computed: {
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            if ([null, undefined].includes(values)) {
              values = vm.$attrs.multiple ? [] : '';
            }

            vm.updateModel(values)
          }
        }
      )
    }
  },
  watch: {
    idsGrupo(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsFilial(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSegmento(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    },
    idsSecao(novo, antigo) {
      this.verificaAtualizacaoFiltros(novo, antigo);
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    verificaAtualizacaoFiltros(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
    updateModel(values) {
      const valuesValidos = values ? values : [];
      this.$emit('update:modelValue', valuesValidos);
    },
    getItems () {
      this.loading = true

      const params = {
        grupos: this.idsGrupo,
        filiais: this.idsFilial,
        segmentos: this.idsSegmento,
        secoes: this.idsSecao,
      };

      api.get('/categorias', { params })
        .then(response => {
          this.items = response.data.categorias;
          this.loading = false;
          this.atualizarFiliaisSelecionadas();
        })
        .catch(logout)
    },
    atualizarFiliaisSelecionadas() {
      if (!this.modelValue) return;

      const itens_selecionados = this.items.filter(item => this.modelValue.some(id => `${id}` === `${item.id}`));
      this.updateModel(arrayColumn(itens_selecionados, 'id'));
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtde_visivel_selecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
